import { render } from "./delivery-per-route-card.vue?vue&type=template&id=4d17200c&ts=true"
import script from "./delivery-per-route-card.vue?vue&type=script&lang=ts"
export * from "./delivery-per-route-card.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__